import { SVGProps } from 'react';

export const BonusesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.19332L9.06404 8.07203C8.80757 8.58553 8.32976 8.93828 7.78081 9.01938L1.89603 9.88875L6.19036 14.3127C6.58933 14.7236 6.77149 15.3121 6.6785 15.8893L5.65176 22.2619L11.2313 19.3473C11.7152 19.0946 12.2848 19.0946 12.7687 19.3473L18.3482 22.2619L17.3215 15.8893C17.2285 15.3121 17.4107 14.7236 17.8097 14.3127L22.104 9.88875L16.2192 9.01938C15.6703 8.93828 15.1924 8.58553 14.9359 8.07203L12 2.19332ZM10.4761 1.17788C11.1187 -0.108835 12.8813 -0.108835 13.5239 1.17788L16.513 7.16293L22.52 8.05035C23.9289 8.25851 24.4994 10.063 23.4861 11.1068L19.1044 15.6209L20.1507 22.1155C20.3842 23.564 18.9446 24.6764 17.6871 24.0196L12 21.0491L6.313 24.0196C5.05538 24.6764 3.61593 23.564 3.84931 22.1155L4.89571 15.6209L0.513888 11.1068C-0.499395 10.063 0.0710321 8.25851 1.48009 8.05035L7.48702 7.16293L10.4761 1.17788Z"
        fill="#282828"
      />
    </svg>
  );
};
